import { GraphQLError } from "graphql/error";
import { getBuildkiteFrontendVersion } from "~/lib/frontendVersion";
const { QueryResponseCache } = require("relay-runtime");

// The cache is a simple in-memory cache
// copied from https://relay.dev/docs/v10.1.3/network-layer/
// This works across all modern relay versions until v10

const oneMinute = 60 * 1000;
const cache = new QueryResponseCache({ size: 250, ttl: oneMinute });

const makeFetch = (operation, variables, cacheConfig) => {
  const queryID = operation.text;
  const isMutation = operation.operationKind === "mutation";
  const isQuery = operation.operationKind === "query";
  const forceFetch = cacheConfig && cacheConfig.force;

  // Try to get data from cache on queries
  const fromCache = cache.get(queryID, variables);
  if (isQuery && fromCache !== null && !forceFetch) {
    return fromCache;
  }

  return fetch(window._graphql.url, {
    method: "POST",
    headers: {
      "X-Buildkite-Frontend-Version": getBuildkiteFrontendVersion(),
      ...window._graphql.headers,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "same-origin",
    body: JSON.stringify({
      query: operation.text,
      variables,
    }),
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      // Update cache on queries
      if (isQuery && json) {
        cache.set(queryID, variables, json);
      }
      // Clear cache on mutations
      if (isMutation) {
        cache.clear();
      }

      if (json && json.errors && json.errors.length) {
        // Surface the operation name and the first error's message/path in the
        // thrown error. The generic "The query failed" message gave every Relay
        // query failure across the app an identical, undiagnosable signature;
        // naming the operation and the offending field makes each error
        // self-describing and searchable in Bugsnag.
        const [firstError] = json.errors;
        // Normalize list indexes (numeric segments) to `*` so the same
        // resolver failure under a list — e.g. `edges.0` vs `edges.4` — stays a
        // single, stable signature instead of fragmenting into per-element variants.
        const path = Array.isArray(firstError?.path)
          ? firstError.path
              .map((segment) => (typeof segment === "number" ? "*" : segment))
              .join(".")
          : undefined;
        const detail = firstError?.message || "unknown error";
        const operationName = operation.name || "anonymous";

        // Attach the operation name and normalized path so the Bugsnag
        // `onError` handler can build a stable grouping hash. These errors are
        // all thrown from this one frame, so without it Bugsnag's stacktrace
        // grouping collapses them into a single group.
        const error = new GraphQLError(
          `GraphQL query "${operationName}" failed: ${detail}${path ? ` (path: ${path})` : ""}`,
          null,
          json,
        ) as GraphQLError & { operationName?: string; graphqlPath?: string };
        error.operationName = operationName;
        error.graphqlPath = path;

        throw error;
      }
      return json;
    });
};

export default makeFetch;
